import React from 'react'
import { Info } from 'react-feather'
import { FormatOptionLabelMeta } from 'react-select'

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { SelectOption } from '@/types/misc'

export interface SingleSelectOptionLabelProps {
  option: SelectOption
  meta: FormatOptionLabelMeta<SelectOption>
  fieldName: string
  isSelected: boolean
  isDisabled?: boolean
  renderDisabledOption?: (label: string) => React.ReactNode
}

const SingleSelectOptionLabel: React.FC<SingleSelectOptionLabelProps> = ({
  option,
  meta,
  isSelected,
  isDisabled,
  renderDisabledOption,
}) => {
  const { label, tooltipHint } = option
  const { context } = meta
  if (context !== 'menu') {
    return label
  }

  return (
    <div className="flex flex-1 items-start">
      <input
        type="radio"
        disabled={isDisabled}
        className="block"
        checked={isSelected || isDisabled}
        style={{
          minWidth: '16px',
          minHeight: '16px',
          margin: '0 9px 0 0',
          position: 'relative',
          top: '2px',
        }}
      />

      <div>
        {isDisabled && renderDisabledOption
          ? renderDisabledOption(label)
          : label}

        {tooltipHint && (
          <Tooltip>
            <TooltipTrigger asChild>
              <Info
                className="text-primary -mt-0.5 ml-2 inline-block"
                size={16}
              />
            </TooltipTrigger>

            <TooltipContent>{tooltipHint.text}</TooltipContent>
          </Tooltip>
        )}
      </div>
    </div>
  )
}

export default SingleSelectOptionLabel
